var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"smallContent"},[_c('div',{staticClass:"elementContainer"},_vm._l((_vm.products),function(item,index){return _c('ShopElement',{key:item.id,attrs:{"item":item}})}),1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }